import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, FormField, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, addMonths, format, parse } from 'date-fns';
import DPModal from '../../../../../components/DPModal';
import BadgeUserType from '../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, exportToExcel, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';



export const ReportsFinancesDelinquencyPage = () => {
  const { menu, parameters } = useGlobalState();

  useGlobalState();
  const { navigate } = useRouter();



  const [report, setReport] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);

  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) {
    if (parameters.date) {

      try {
        setLoading(true)
        const body: any = {
          dateStart: parameters.startDate,
          dateEnd: parameters.endDate,
          orderBy: "dateTransaction",
          order: "desc",
          orderBy2: "idMovement",
          order2: "desc",
          columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK"
        };

        // Conditionally add idAccountPlan
        if (parameters.idAccountPlan && parameters.idAccountPlan > 0) {
          body.idAccountPlan = parameters.idAccountPlan;
        }
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/reports/finance/latepayments',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify({ date: parameters.date }),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {
          setReport(data.report);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  useEffect(() => {
    handleRefreshMovements()
  }, [parameters.date]);
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={
            <SpaceBetween direction='horizontal' size='xs'>
              <Favorites />
            </SpaceBetween>
          }>Morosidades</Header>

          <Table
            variant='embedded'
            filter={
              <SpaceBetween direction='horizontal' size='xs'>
                <FormField label="Fecha corte">
                  <DPModal today date={parameters.date || ""} onConfirm={function (selectedDate: string): void {

                    setParameters({ ...parameters, date: selectedDate });
                  }}
                  />
                </FormField>
                <FormField label="&nbsp;">
                  {report && report.length > 0 && (
                    <Button onClick={() => {
                      exportToExcel(report, `Morosidades ${parameters.date}.xlsx`)
                    }} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>)}
                </FormField>
              </SpaceBetween>



            }
            wrapLines

            columnDefinitions={[
              {
                id: 'idUser',
                header: 'Usuario',
                cell: (item) => (<><BadgeUserType size='small' type='min' idUserType={item.idUserType}></BadgeUserType>{item.displayName}</>),
              },
              {
                id: 'income12',
                header: <FormField label={'12 meses'}>
                  {/* 🛑 FIX: Check if parameters.date exists before parsing/formatting */}
                  {parameters.date ?
                    <small>{format(addMonths(parse(parameters.date, "dd-MM-yyyy", new Date()), -12), "dd-MM-yyyy")}</small>
                    : <small>--</small>
                  }
                </FormField>,
                cell: (item) => item.n12 < 0 ? <strong>{formatCurrency(item.n12, 'CLP')}</strong> : formatCurrency(item.n12, 'CLP'),
                width: 120,
              },
              {
                id: 'income6',
                header: <FormField label={'6 meses'}>
                  {/* 🛑 FIX: Check if parameters.date exists before parsing/formatting */}
                  {parameters.date ?
                    <small>{format(addMonths(parse(parameters.date, "dd-MM-yyyy", new Date()), -6), "dd-MM-yyyy")}</small>
                    : <small>--</small>
                  }
                </FormField>,
                cell: (item) => item.n6 < 0 ? <strong>{formatCurrency(item.n6, 'CLP')}</strong> : formatCurrency(item.n6, 'CLP'),
                width: 120,
              },
              {
                id: 'income3',
                header: <FormField label={'3 meses'}>
                  {/* 🛑 FIX: Check if parameters.date exists before parsing/formatting */}
                  {parameters.date ?
                    <small>{format(addMonths(parse(parameters.date, "dd-MM-yyyy", new Date()), -3), "dd-MM-yyyy")}</small>
                    : <small>--</small>
                  }
                </FormField>,
                cell: (item) => item.n3 < 0 ? <strong>{formatCurrency(item.n3, 'CLP')}</strong> : formatCurrency(item.n3, 'CLP'),
                width: 120,
              },
              {
                id: 'income0',
                header: <FormField label={'Actual'}>
                  {/* 🛑 FIX: Check if parameters.date exists before parsing/formatting */}
                  {parameters.date ?
                    <small>{format(addDays(parse(parameters.date, "dd-MM-yyyy", new Date()), 0), "dd-MM-yyyy")}</small>
                    : <small>--</small>
                  }
                </FormField>,
                cell: (item) => item.n0 < 0 ? <strong>{formatCurrency(item.n0, 'CLP')}</strong> : formatCurrency(item.n0, 'CLP'),
                width: 120,
              },
            ]}
            items={report || []}
            loadingText="Cargando morosidades..."
          />
        </SpaceBetween>
      }
    />
  );
};
